import { Document, User } from "@/models";
import { DocumentStatus } from "../Document";
export default class OperativePlan extends Document {
  static type = "documentOperativePlans";

  static statuses: DocumentStatus = [...Document.statuses];

  statusLabel(user: User) {
    const status = OperativePlan.statuses.find((o) => o.id === this.status);
    return status?.labels[user.role] || status?.labels.default;
  }

  get statusClass() {
    const status = OperativePlan.statuses.find((o) => o.id === this.status);
    return status?.class;
  }

  get initiativeStatus() {
    const withoutSuperClass = OperativePlan.type.replace("document", "");
    return (
      withoutSuperClass.charAt(0).toLocaleLowerCase() +
      withoutSuperClass.slice(1)
    );
  }
}
